import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { SubmitTradeReviewInput } from 'shared';

import { submitTradeReview } from '../../lib/api/endpoints';
import { notificationKeys } from '../notifications/queries';
import { positionKeys } from '../positions/queries';

import { reviewKeys } from './queries';
import { tradeReviewKeys } from './useReviewContext';

export function useSubmitReview(accountId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: { tradeId: string; body: SubmitTradeReviewInput }) =>
      submitTradeReview(input),
    onSuccess: (_review, input) => {
      void queryClient.invalidateQueries({ queryKey: tradeReviewKeys.context(input.tradeId) });
      void queryClient.invalidateQueries({ queryKey: reviewKeys.pending() });
      void queryClient.invalidateQueries({ queryKey: reviewKeys.all });
      void queryClient.invalidateQueries({ queryKey: notificationKeys.all });
      void queryClient.invalidateQueries({ queryKey: positionKeys.tradingNextActions(accountId) });
      void queryClient.invalidateQueries({ queryKey: ['journal'] });
      void queryClient.invalidateQueries({ queryKey: ['tradePlans'] });
    },
  });
}
